import { NavigationStyles } from '@generated/graphql';
import { SwapHoriz } from '@mui/icons-material';
import { UserContext } from '@providers/userContextProvider';
import { Box } from 'hephaestus/web';
import { type ReactNode, useContext, useState } from 'react';
import { OrganizationSwitcherModal } from './OrganizationSwitcherModal';

export type OrganizationSwitcherProp = {
  children: ReactNode;
};

export const OrganizationSwitcher = ({
  children,
}: OrganizationSwitcherProp) => {
  const { userContext } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const isUnifiedClientExperience =
    userContext.role?.navigationStyle === NavigationStyles.Simple;

  return (
    <>
      <Box
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={() => !isUnifiedClientExperience && setOpen(true)}
        sx={{
          cursor: !isUnifiedClientExperience ? 'pointer' : 'inherit',
          position: 'relative',
        }}
      >
        {children}
        <SwapHoriz
          sx={{
            fontSize: '1.5rem',
            position: 'absolute',
            right: hover ? -30 : -10,
            top: '50%',
            transform: 'translateY(-50%)',
            transition: 'all 0.3s',
            opacity: !isUnifiedClientExperience && hover ? 1 : 0,
          }}
        />
      </Box>
      <OrganizationSwitcherModal open={open} setOpen={setOpen} />
    </>
  );
};
